<template>
  <div class="">
    <div class="box-item top mb_20">
      <z-collapse :title="$t('loan.contract')" :isToggle="true">
        <div class="card-box" v-if="contract && contract.length>0">
          <div class="single-card" v-for="(item,index) in contract" :key="index">
            <z-card :title="applyStatus[item.applyStatus]">
              <ul class="card-list">
                <li><span class="tit">{{ $t('loan.contractNo') }}</span><div class="msg">{{item.contractNumber}}</div></li>
                <!--              合同号-->
                <li><span class="tit">{{ $t('loan.buyer') }}</span><div class="msg">{{item.buyer}}</div></li>
                <!--              买方-->
                <li><span class="tit">{{ $t('loan.buyerCountry') }}</span><div class="msg">{{item.buyerCountry}}</div></li>
                <!--              买方所属国-->
                <li><span class="tit">{{ $t('loan.seller') }}</span><div class="msg">{{item.seller}}</div></li>
                <!--              卖方-->
                <li><span class="tit">{{ $t('loan.sellerCountry') }}</span><div class="msg">{{item.sellerCountry}}</div></li>
                <!--              买方所属国-->
                <li><span class="tit">{{ $t('loan.goodsCategory') }}</span><div class="msg">{{item.productType}}</div></li>
                <!--              商品类别-->
                <li><span class="tit">{{ $t('loan.goodsName') }}</span><div class="msg">{{item.productName}}</div></li>
                <!--              商品名称-->
                <li><span class="tit">{{ $t('loan.contractNumber') }}</span><div class="msg">
                  {{item.contractQuantity | formatNum}} {{item.contractQuantityUnit}}&nbsp;( +{{item.contractUpperLimit}}%-{{item.contractLowerLimit}}% )
                </div></li>
                <!--              合同数量-->

                <li><span class="tit">{{ $t('loan.unitPrice') }}</span><div class="msg">
                  <span v-if="item.price">{{item.price}}</span> {{item.priceCurrency}}/{{item.priceUnit}}
                </div></li>
                <!--              单价-->
                <li><span class="tit">{{ $t('loan.packaging') }}</span><div class="msg">{{item.pack}}</div></li>
                <!--              包装-->
                <li><span class="tit">{{ $t('loan.amount') }}</span><div class="msg">
                  {{item.currency}} {{item.money | formatNum }}&nbsp;( +{{item.moneyUpperLimit}}%-{{item.moneyLowerLimit}}% )
                </div></li>
                <!--              金额-->

                <li><span class="tit">{{ $t('loan.paymentWay') }}</span><div class="msg">{{item.rpaymentMethod}}</div></li>
                <!--              付款方式-->
                <li><span class="tit">{{ $t('loan.paymentDays') }}</span><div class="msg">{{item.paymentDays}}</div></li>
                <!--              账期-->
                <li><span class="tit">{{ $t('loan.tradeTerms') }}</span><div class="msg">{{item.tradeTerms}}</div></li>
                <!--              贸易条款-->
                <li><span class="tit">{{ $t('loan.shipmentDate') }}</span><div class="msg">{{item.esTimeShip }}</div></li>
                <!--              装船日期-->
                <li><span class="tit">{{ $t('loan.loadingPort') }}</span><div class="msg">{{item.loadPort}}</div></li>
                <!--              装货港-->
                <li><span class="tit">{{ $t('loan.dischargePort') }}</span><div class="msg">{{item.dischargePort}}</div></li>
                <!--              卸货港-->
                <li><span class="tit">{{ $t('loan.originCountry') }}</span><div class="msg">{{item.countryOfOrigin}}</div></li>
                <!--              原产国-->
                <li><span class="tit">{{ $t('loan.tradeContract') }}</span>
                  <div class="msg c-file-list" v-if="item.transactionContractFileList && item.transactionContractFileList.length>0">
                    <a target="_blank" v-for="(listItem, index) in item.transactionContractFileList" :key="index" :href="zmaDownloadFile(listItem.fileCode)"><i class="file-icon" :class="getFileType(listItem.fileName)"></i>{{listItem.fileName}}</a>
                  </div>
                </li>
                <!--交易合同-->
              </ul>
            </z-card>
          </div>
          <!--采购合同、销售合同、终端合同-->
        </div>
      </z-collapse>
    </div>
  </div>
</template>
<script>
  import mixins from '@/helper/mixins.js';
  import ZCollapse from "@/components/ZCollapse";
  import ZCard from "@/components/ZCard";
  export default {
    name: "cicContract",
    props: ["contract"],
    mixins: [mixins],
    computed: {
    },
    components: {
      ZCollapse,
      ZCard
    },
    data() {
      return {
        value: '',
        applyStatus:{
          '1':this.$t('loan.buyContract'),
          '2':this.$t('loan.saleContract'),
          '3':this.$t('loan.terminalContract'),
        },
      };
    },
    methods: {

    }
  };
</script>

<style lang="scss" scoped>
  .c-list.edit{
    .msg{
      width: 520px;
    }
  }
  .card-box{
    padding: 9px 0 19px;
    display: flex;
    justify-content: flex-start;
    .single-card + .single-card{
      margin-left: 15px;
    }
    .card-item{
      width: 330px;
    }
  }
</style>

